const loadPlaceSearch = (callback?: Function) => {
  const existingScript = document.getElementById('placesSearchWidget');

  if (!existingScript) {
    const script = document.createElement('script');

    script.src =
      'https://api.mqcdn.com/sdk/place-search-js/v1.0.0/place-search.js';
    script.id = 'placesSearchWidget';
    script.type = 'text/javascript';

    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};

export { loadPlaceSearch };
